module.exports = {"section_releases_title":"Releases","section_shows_title":"Live"}